import MyPageNavbar from "../components/MyPageNavbar";
import MyPageBody from "../components/MyPageBody";

const MyPage = () => {
    return (
        <div>
            <MyPageNavbar />
            <MyPageBody />
        </div>
    );
};

export default MyPage;
